import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_CONTACT_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- callPaymentGateway --------*/

  requestCallPaymentGateway: [
    "userId",
    "bookingId",
    "rememberCard",
    "card",
    "amount"
  ],
  callPaymentGatewaySuccess: ["callPaymentGatewayResponse"],
  callPaymentGatewayFailure: ["callPaymentGatewayError"],
  /*---------- getPaymentToken --------*/

  requestGetPaymentToken: ["rememberCard", "card"],
  getPaymentTokenSuccess: ["getPaymentTokenResponse"],
  getPaymentTokenFailure: ["getPaymentTokenError"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaPaymentTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagaPaymentInitState = {
  paymentDetail: []
}

export const INITIAL_STATE = Immutable(SagaPaymentInitState)

/* ------------- Reducers ------------- */

/*---------- callPaymentGateway --------*/

export const requestCallPaymentGateway = (state: Immutable) => {
  return state.merge({
    callPaymentGatewayFetching: true
  })
}
export const callPaymentGatewaySuccess = (state: Immutable, action) => {
  return state.merge({
    callPaymentGatewayFetching: false,
    callPaymentGatewayResponse: action.callPaymentGatewayResponse
  })
}
export const callPaymentGatewayFailure = (state: Immutable, action) => {
  return state.merge({
    callPaymentGatewayFetching: false,
    callPaymentGatewayError: action.callPaymentGatewayError
  })
}

/*---------- getPaymentToken --------*/

export const requestGetPaymentToken = (state: Immutable, action) => {
  return state.merge({
    getPaymentTokenFetching: true,
    rememberCard: action.rememberCard,
    card: action.card
  })
}
export const getPaymentTokenSuccess = (state: Immutable, action) => {
  return state.merge({
    getPaymentTokenFetching: false,
    getPaymentTokenResponse: action.getPaymentTokenResponse
  })
}
export const getPaymentTokenFailure = (state: Immutable, action) => {
  return state.merge({
    getPaymentTokenFetching: false,
    getPaymentTokenError: action.getPaymentTokenError
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- callPaymentGateway --------*/

  [Types.REQUEST_CALL_PAYMENT_GATEWAY]: requestCallPaymentGateway,
  [Types.CALL_PAYMENT_GATEWAY_SUCCESS]: callPaymentGatewaySuccess,
  [Types.CALL_PAYMENT_GATEWAY_FAILURE]: callPaymentGatewayFailure,

  /*---------- getPaymentToken --------*/

  [Types.REQUEST_GET_PAYMENT_TOKEN]: requestGetPaymentToken,
  [Types.GET_PAYMENT_TOKEN_SUCCESS]: getPaymentTokenSuccess,
  [Types.GET_PAYMENT_TOKEN_FAILURE]: getPaymentTokenFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaPayment/sagaPaymentRedux.ts